/** Empty state component for CDRs page. */
import React from "react";
import { Box, Typography, Paper, Button } from "@mui/material";
import {
  SearchOff as SearchOffIcon,
  FilterListOff as FilterListOffIcon,
} from "@mui/icons-material";

interface EmptyStateProps {
  type: "first_time" | "no_results";
  onClearFilters?: () => void;
}

/** Empty state component showing contextual messages based on filter state. */
export default function EmptyState({ type, onClearFilters }: EmptyStateProps) {
  return (
    <Paper
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 400,
        p: 4,
      }}
    >
      <Box sx={{ textAlign: "center", maxWidth: 500 }}>
        {type === "first_time" ? (
          <>
            <SearchOffIcon
              sx={{ fontSize: 64, color: "text.secondary", mb: 2 }}
            />
            <Typography variant="h5" gutterBottom>
              Welcome to CDRs!
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Start by selecting a date range or adjusting filters to view call
              detail records.
            </Typography>
          </>
        ) : (
          <>
            <FilterListOffIcon
              sx={{ fontSize: 64, color: "text.secondary", mb: 2 }}
            />
            <Typography variant="h5" gutterBottom>
              No Call Records Found
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              No call records match your current filters. Try a different date
              range or clear your filters.
            </Typography>
            {onClearFilters && (
              <Button
                variant="contained"
                onClick={onClearFilters}
                startIcon={<FilterListOffIcon />}
              >
                Clear Filters
              </Button>
            )}
          </>
        )}
      </Box>
    </Paper>
  );
}
